import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import Svg from 'svg-inline-react';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import FrankLogoWhiteSvg from '@src/svgs/frank-logo-new.svg';
import { FrankLogoGlowProps } from './props';
import './styles.scss';

export const FrankLogoGlow: FC<FrankLogoGlowProps> = ({ className }) => {
  const [isLogoShown, setIsLogoShown] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLogoShown(true);
    }, 2000);
  }, []);

  return (
    <div className={classNames('frank-icon-glow', className)}>
      <video
        autoPlay
        className={classNames('frank-icon-glow__glow', isLogoShown && 'frank-icon-glow__glow--hidden')}
        loop
        muted
        src={`${STATIC_MEDIA_DOMAIN}/mp4/virtual-recruiter-glow.mp4`}
      />

      <Svg
        className={classNames('frank-icon-glow__icon', isLogoShown && 'frank-icon-glow__icon--shown')}
        src={FrankLogoWhiteSvg}
      />
    </div>
  );
};
